import React, { useState } from "react";
import { Button } from "react-bootstrap";

export default function ConfirmButton({ disabled, myFunction, myName, myText, myIcon, myStyle, myClassName }) {
   const [askConfirm, setAskConfirm] = useState(false);

   return (
      <div>
        <div className={myClassName}
            title={myText}
            style={myStyle}
            onClick={(e) => {
               e.stopPropagation();
               setAskConfirm(true);
            }}
         >
            {myIcon && <img src={myIcon} />}
            {myName && <span>{myName}</span>} </div>
         {askConfirm && (
            <div className="confirm-box">
               <h5>{myText}</h5>
               <div className="confirm-buttongroup">
                  <div
                     className="btn btn-primary m-1"
                     disabled={disabled}
                     onClick={async (e) => {
               e.stopPropagation();
                        await myFunction();
                        setAskConfirm(false);
                     }}
                  >
                     Bestätigen
                  </div>
                  <div className="btn btn-outline-secondary m-1" onClick={(e) => {
               e.stopPropagation();
               setAskConfirm(false);
            }}>
                     Abbrechen
                  </div>{" "}
               </div>
            </div>
         )}
      </div>
   );
}
